import React from "react";
import "../NavBar.css";
import { Dropdown, Checkbox } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
import { useDispatch } from "react-redux";
import { toggle } from "../../redux/solarSensors";
import { toggleInfoBpx } from "../../redux/infoBoxGeneral";
import { toggleWindDirection } from "../../redux/windDirection";
import { updateFilter } from "../../redux/sceneGlobal";
import { useTheme } from "../../styles/themes/themeContext";

const DropDownSunHours = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  var inputData = props.inputData;

  return (
    <Dropdown item simple text={props.title} className="drop-down">
      <Dropdown.Menu className="kkk">
        {inputData.map((title, id) => (
          <Dropdown.Item
            key={id}
            onClick={() => {
              const action =
                props.wind === "false" ? toggle(id) : toggleWindDirection(id);
              dispatch(action);
              dispatch(
                updateFilter([
                  `${props.parentTitle} >> ${props.title} >> ${title}`,
                ]),
              );
            }}
          >
            <Checkbox
              radio
              checked={props.status.checkStatus[id]}
              label={title}
              key={id}
            />
            <button
              style={{ background: "none", border: "none" }}
              onClick={() => {
                dispatch(toggleInfoBpx([title]));
              }}
            >
              <i
                className="info circle icon"
                style={{ marginLeft: "5px", color: theme.primary }}
              ></i>
            </button>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropDownSunHours;
